import { render, staticRenderFns } from "./member-purchase-order-table.vue?vue&type=template&id=31ff2f33&"
import script from "./member-purchase-order-table.vue?vue&type=script&lang=js&"
export * from "./member-purchase-order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports